import { z } from 'zod'

/**
 * 問題答覆 - 新增 Request Schema
 */
export const createServiceIssueRequestSchema = z.object({
  /** 產品主類目 ID */
  pmID: z.number(),
  /** 問題分類 */
  serviceClass: z.string(),
  /** 問題標題 */
  topic: z.string().optional(),
  /** 問題描述 */
  content: z.string().optional(),
  /** 產品版本 */
  productVersion: z.string(),
  /** 作業系統 */
  osType: z.string()
})

/**
 * 問題答覆 - 新增 Request
 */
export interface CreateServiceIssueRequest
  extends z.infer<typeof createServiceIssueRequestSchema> {}
